import { http, HttpResponse } from 'msw'

import { allServices } from 'app/mocks/data/users/services'

import {
    api,
    isNumeric,
    queryIntoArrayNumber,
    SEARCH_PARAM_LIMIT,
    SEARCH_PARAM_OFFSET,
} from 'app/utils/constants'
import { searchParametersServicesApi } from 'app/utils/users/services'

import { ServicesRequest } from 'app/types/users/service'

export const getAllServices = http.get(
    `${process.env.REACT_APP_API_ADDRESS}/${api.users.services.LIST}`,
    ({ request }) => {
        const { searchParams } = new URL(request.url)
        const limitQuery = searchParams.get(SEARCH_PARAM_LIMIT)
        const offsetQuery = searchParams.get(SEARCH_PARAM_OFFSET)

        const managerIdsFilter = searchParams.get(
            searchParametersServicesApi.MANAGERS,
        )

        const clientIdsFilter = searchParams.get(
            searchParametersServicesApi.CLIENTS,
        )

        const nameFilter = searchParams.get(searchParametersServicesApi.NAME)

        let allServicesFiltered = allServices

        // Manager filter
        if (managerIdsFilter) {
            const managerIdsSplit = queryIntoArrayNumber(managerIdsFilter)

            allServicesFiltered = allServicesFiltered.filter((service) =>
                managerIdsSplit.includes(service.client.client.id),
            )
        }

        // Client filter
        if (clientIdsFilter) {
            const clientIdsSplit = queryIntoArrayNumber(clientIdsFilter)

            allServicesFiltered = allServicesFiltered.filter((service) =>
                clientIdsSplit.includes(service.client.id),
            )
        }

        // Name filter
        if (nameFilter) {
            allServicesFiltered = allServicesFiltered.filter((service) =>
                service.name.toLowerCase().includes(nameFilter.toLowerCase()),
            )
        }

        // Pagination
        const limit = isNumeric(limitQuery) ? Number(limitQuery) : 10
        const offset = isNumeric(offsetQuery) ? Number(offsetQuery) : 0

        const limitArray =
            allServicesFiltered.length > limit
                ? offset + limit
                : allServicesFiltered.length

        const results = allServicesFiltered.slice(offset, limitArray)

        const next =
            offset + results.length < allServicesFiltered.length
                ? 'again'
                : undefined

        return HttpResponse.json<ServicesRequest>({
            next,
            results,
        })
    },
)
